import React from 'react';
import "./mobilePanel.scss";
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';


const MobilePanel = (props) => {
  let uvColor = "greenBox"

  if (props.uv==="3" || props.uv==="4" || props.uv==="5" || props.uv==="6" || props.uv==="7")
    uvColor = "orangeBox"

  if (props.uv==="8" || props.uv==="9" || props.uv==="10" || props.uv==="11")
    uvColor = "redBox"

  return (
     <Hidden smUp>
               
          <Grid container style={{padding:'16px 16px  0 16px'}}>
        <Grid item xs={6} sm={6} md={6} lg={6} style={{textAlign:'left', paddingBottom:'16px', borderBottom:'1px solid #7d7d7d'}}>
        {props.description}
  
</Grid>
<Grid item xs={6} sm={6} md={6} lg={6}  style={{textAlign:'Right', paddingBottom:'16px', borderBottom:'1px solid #7d7d7d'}}>
  <div>Max UV <span style={{marginLeft: "10px"}} className={uvColor}>{props.uv}</span></div> 

</Grid>

</Grid>

      </Hidden>
  )
}

export default MobilePanel
